import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-6 pt-2 gap-6 h-screen" }
const _hoisted_2 = { class: "w-full h-screen bg-white rounded-md pt-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8" }, "SignIn with the google account you were invited to via invitation.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_GoogleLogin, { onAuthorized: _ctx.authorized }, null, 8, ["onAuthorized"]),
        _hoisted_3
      ])
    ])
  ]))
}